// @flow
import React from 'react';

import { COLUMN_1, COMPOSITE_1 } from 'Components/frameworks/card/Card.constants';

import { Card } from 'Components/frameworks/card/Card.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  associatedProductLabel: string,
  config: CMSContent,
  countryPoi: Array<{
    associatedProducts: null | Array<{ href: string, name: string }>,
    description: string,
    media: null | { mediaAlt: string, mediaUrl: string },
    seeMoreLabel: string,
    title: string,
  }>,
  id?: string,
};

function getCtaLabel(associatedProductLabel, productName) {
  return productName ? `${associatedProductLabel} ${productName}`.trim() : '';
}

export function CountryPoiLine({
  associatedProductLabel = '',
  config: {
    common: { close },
  },
  countryPoi = [],
  id,
}: Props) {
  const cards = countryPoi.map(
    ({ associatedProducts = [], description = '', media, seeMoreLabel = '', title = '' }) => {
      return {
        closeLabel: close,
        ctaLabel: getCtaLabel(
          associatedProductLabel,
          associatedProducts && associatedProducts[0] ? associatedProducts[0].name : '',
        ),
        heading: {
          title,
          hLevel: 3,
        },
        link: {
          url: associatedProducts && associatedProducts[0] ? associatedProducts[0].href : '',
        },
        media: {
          url: media ? media.mediaUrl : '',
          alt: media ? media.mediaAlt : '',
        },
        text: {
          text: description,
          seeMoreLabel,
        },
        theme: 'landing',
      };
    },
  );

  if (!cards.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      {cards.length > 1 ? (
        <div className="sm:flex sm:flex-wrap -m-2">
          {cards.map(card => (
            <div className="sm:w-1/2 p-2" key={card.heading.title}>
              <Card {...card} layout={COLUMN_1} />
            </div>
          ))}
        </div>
      ) : (
        <Card {...cards[0]} layout={COMPOSITE_1} />
      )}
    </SiteContainer>
  );
}
